export default "__VITE_ASSET__CKxO1c25__"